import React from 'react';
import TeamSection from './components/TeamSection';
import './App.css';



function App() {
  return (
    <div className="App">
      <TeamSection />
    </div>
  );
}


export default App;
